import {getCookie} from "./utils/getCookie";
import {setCookie} from "./utils/setCookie";
import PhoneMask from 'phone-mask-international/dist/PhoneMask';

window.getCookie = getCookie;
window.setCookie = setCookie;

window.openRecordFormModal = function (
  {
    title = 'Заказать консультацию',
    subtitle = '',
    submitCallback = null,
    purpose = null,
    withLanguage = false,
    withoutPhoneMask = false,
    withoutPrivacyLinks = false,
    namePlaceholder = 'Ваше имя*',
  }) {

  var modal = new tingle.modal({
    closeLabel: '',
    cssClass: ['record-form-modal'],
    onClose () {
      modal.destroy()
    },
    onOpen () {
      let form = modal.modalBox.querySelector('.record-form-js')
      form.submitCallback = () => {
        modal.close()
      }

      initRecordForm(form, submitCallback)
    },
  })

  let email = window.recordFormData ? window.recordFormData.email || '' : ''
  let phone = window.recordFormData ? window.recordFormData.phone || '' : ''
  let name = window.recordFormData ? window.recordFormData.name || '' : ''

  let langContent = !withLanguage ? '' : `
    <label class="label-input select-label"> 
      <select name="language" required="">
        <option value="1">Английский язык</option>
        <option value="2">Французский язык</option>
        <option value="3">Немецкий язык</option>
        <option value="4">Итальянский язык</option>
        <option value="5">Испанский язык</option>
      </select> 
    </label>
  `

  // language=HTML
  let content = `
      <h2 class="section-header">${title}</h2>
      <p class="center">${subtitle}</p>
      <form action="/" class="record-form-js" data-purpose="${purpose || ''}">
          <label class="label-input">
              <input type="text" name="name" placeholder="${namePlaceholder}" required
                     value="${name}">
              <span class="invalid"></span>
          </label>
          <label class="label-input">
              <input type="email" name="email" placeholder="E-mail*" required
                     value="${email}">
              <span class="invalid"></span>
          </label>
          <label class="label-input">
              <input type="text" name="phone" placeholder="Телефон*" required
                     value="${phone ? phone : (withoutPhoneMask ? '+' : '')}" ${withoutPhoneMask ? ' class="no-mask"' : ''}>
              <span class="invalid"></span>
          </label>
          ${langContent}

          ${withoutPrivacyLinks ? '' : '<p class="agree center">Нажимая кнопку "Оставить заявку", вы принимаете\n            <a href="https://www.soho-bridge.ru/rules/" class="link-green" target="_blank"> Правила оказания услуг</a> и\n            условия\n            <a href="https://www.soho-bridge.ru/privacy/" class="link-green" target="_blank">Политики\n              конфиденциальности</a>\n          </p>'}

          <input type="hidden" name="title"
                 value="Новая заявка - ${title}. ${subtitle}">
          <input type="hidden" name="action" value="siteWideMessage">
          <input type="hidden" name="page" value="${document.location.href}">

          <div class="center">
              <button class="btn btn-green btn-md">Записаться</button>
          </div>
      </form>
  `

  modal.setContent(content)
  modal.open()
}

window.validateRecordForm = function (
  form, emailInput = null, telInput = null) {
  let isValid = true
  emailInput = emailInput || form.elements.email
  telInput = telInput || form.elements.phone
  let emailInvalidBlock = emailInput.parentNode.querySelector('.invalid')
  let telInvalidBlock = telInput.closest('label').querySelector('.invalid')

  if (!/^.+@.+$/.test(emailInput.value)) {
    if (emailInput.changed) {
      emailInvalidBlock.innerText = 'Некорректный E-mail'
    }
    isValid = false
  } else {
    emailInvalidBlock.innerText = ''
  }

  if (telInput.value.length < 10) {
    if (telInput.changed) {
      telInvalidBlock.textContent = 'Некорректный номер телефона'
    }
    isValid = false
  } else {
    telInvalidBlock.innerText = ''
  }

  return isValid
}

window.initTelMask = function (input) {
  let cont = input.parentNode;
  cont.classList.add('phone-mask-cont');
  let contInner = document.createElement('span');
  contInner.className = 'phone-mask-inner-cont';
  cont.prepend(contInner);
  contInner.appendChild(input);
  input.type = 'hidden';
  let mask = new PhoneMask(input);



  // changed forwarding
  mask.phoneInput.addEventListener('input', () => {
    $(input).trigger('input');
  });
  mask.countryInput.addEventListener('input', () => {
    $(input).trigger('input');
  });

  mask.phoneInput.addEventListener('change', () => {
    $(input).trigger('change');
  });
  mask.countryInput.addEventListener('change', () => {
    $(input).trigger('change');
  });

  mask.phoneInput.addEventListener('paste', () => {
    $(input).trigger('change');
  });
  mask.countryInput.addEventListener('paste', () => {
    $(input).trigger('change');
  });

  return mask;
}

//revalidate inputs after change/input
window.hotValidationInit = function (form) {
  $(form).find('input').on('input', function () {
    if (!window.recordFormData) {
      window.recordFormData = {}
    }
    window.recordFormData[this.name] = this.value
    let form = this.closest('form')
    form.validate();
  })

  $(form).find('input').on('change', function () {
    //Показываем ошибки только после первого наступления события change
    //иначе юзер, пока в первый раз вводит, сойдет с ума от ошибок валидации
    this.changed = true

    let form = this.closest('form')
    form.validate()
  })

}

window.initRecordForm = function (form, submitCallback = null) {
  form.validate = function () {
    return validateRecordForm(this)
  }

  hotValidationInit(form)

  // tel mask
  if(!form.elements.phone.classList.contains('no-mask'))
    initTelMask(form.elements.phone)

  //bind form submit
  form.addEventListener('submit', function (e) {
    if (typeof submitCallback === 'function') {
      submitCallback({ e, form: this })
      return
    }
    e.preventDefault()

    this.querySelectorAll('input').forEach(input => {
      input.changed = true
    })

    if (!this.validate()) {
      return
    }

    sendRecordForm(this)
  })
}

window.sendRecordForm = function (form) {
  let data = $(form).serialize()

  $.post('/wp-admin/admin-ajax.php', data, function () {
    let globalPurpose = document.body.getAttribute('data-purpose')
    let purpose = globalPurpose || form.getAttribute('data-purpose')
    if (purpose)
      reachMetricGoal(purpose)

    if (typeof form.submitCallback === 'function') {
      form.submitCallback()
    }

    openModal('Спасибо за заявку. В ближайшее время мы с вами свяжемся')

  })
}

window.showLoadingOverlay = () => {
  $(document.body).append('<div class="loading-overlay"></div>')
}

window.hideLoadingOverlay = () => {
  $('.loading-overlay').remove()
}

window.openModal = function (content, settings = {}) {
  var modal = new tingle.modal({
    closeLabel: '',
    onClose () {
      modal.destroy()
    },
    ...settings,
    onOpen () {
      if (typeof settings.onOpen === 'function') {
        settings.onOpen(modal)
      }
    },
  })

  modal.setContent(content)
  modal.open()
  return modal
}

window.initCouponInput = function (couponInput, accessory_type) {
  let form = couponInput.closest('form')
  let successSpan = couponInput.parentNode.querySelector('.success')
  let meta = form.elements.meta.value
  let amountInput = form.elements.amount
  let signatureInput = form.elements.signature
  let signatureStart = signatureInput.value
  let amountStart = amountInput.value

  couponInput.addEventListener('input', function () {
    if (!couponInput.value) {

      couponInput.setCustomValidity('')
      try {
        couponInput.closest('label').querySelector('.invalid').innerText = '';
      }catch (e) {}
      // Нет купона - сбрасываем данные
      successSpan.innerText = ''
      amountInput.value = amountStart
      signatureInput.value = signatureStart
      form.elements.coupon_id.value = null
      form.disabledTmp = false
      return
    }

    let data = new FormData(form)
    data.append('accessory_type', accessory_type)
    data.append('meta', meta)
    data.append('code', couponInput.value)
    let startCode = couponInput.value;

    form.disabledTmp = true
    $.ajax({
      url: '/wp-json/api/v1/promo-codes/check',
      method: 'POST',
      data,
      processData: false,
      contentType: false,

      success (data) {
        if(couponInput.value !== startCode)
          return;
        let coupon = data.coupon
        if (!coupon) {
          // Нет купона - сбрасываем данные
          successSpan.innerText = ''
          amountInput.value = amountStart
          signatureInput.value = signatureStart
          form.elements.coupon_id.value = null
          couponInput.setCustomValidity(
            'Вы указали неверный купон. Проверьте его правильность')
          try {
            couponInput.closest('label').querySelector('.invalid').innerText = 'Вы указали неверный купон. Проверьте его правильность';
          }catch (e) {}
        } else {
          couponInput.setCustomValidity('')
          try {
            couponInput.closest('label').querySelector('.invalid').innerText = '';
          }catch (e) {}
          amountInput.value = data.price ? data.price : amountStart
          signatureInput.value = data.signature
            ? data.signature
            : signatureStart
          form.elements.coupon_id.value = coupon.id

          let text = 'Активный купон. '
          if (coupon.type === 'discount') {
            text += 'Скидка ' + parseFloat(coupon.discount) +
              (coupon.discount_type === 'percent' ? '%' : ' р')
            text += '. К оплате ' + data.price + ' р.'
          } else {
            text += 'Бонусных занятий: ' + coupon.bonus_lessons
            amountInput.value = amountStart
          }
          successSpan.innerText = text
        }

        form.disabledTmp = false
      },
    })
  })
}

window.openPaymentForm = function (params) {
  $.post('/wp-admin/admin-ajax.php', {
    ...params,
    action: 'get_order_form',
  }, content => {
    var modal = new tingle.modal({
      closeLabel: '',
      cssClass: ['order-form-modal'],
      onClose () {
        modal.destroy()
      },
      onOpen () {

        let telInput = modal.modalBox.querySelector('[name="client_phone"]')
        let emailInput = modal.modalBox.querySelector('[name="client_email"]')
        let nameInput = modal.modalBox.querySelector('[name="client_name"]')
        let couponInput = modal.modalBox.querySelector('[name="coupon"]')
        if (window.recordFormData) {
          telInput.value = window.recordFormData.client_phone || ''
          emailInput.value = window.recordFormData.client_email || ''
          nameInput.value = window.recordFormData.client_name || ''
        }

        initTelMask(telInput)
        initCouponInput(couponInput, 'lessons')

        let form = modal.modalBox.querySelector('form')
        form.validate = function () {
          return validateRecordForm(this, emailInput, telInput)
        }

        hotValidationInit(form)

        //bind form submit
        form.addEventListener('submit', function (e) {
          if (this.disabledTmp) {
            e.preventDefault()
            return
          }
          this.querySelectorAll('input').forEach(input => {
            input.changed = true
          })

          if (!this.validate()) {
            e.preventDefault()
          }
        })
      },
    })

    modal.setContent(content)
    modal.open()
  })
}

//обёртка для локального тестирования
window.reachMetricGoal = function (goal) {
  try {
    yaCounter22187260.reachGoal(goal)
  } catch (e) {
    console.log(goal)
  }
}